export enum AuthDispatchTypeEnum {
   LOAD_USER = "LOAD_USER",
   LOGOUT_USER = "LOGOUT_USER",
   LOAD_TOKEN = "LOAD_TOKEN",
   LAOD_HIGH_SCORE = "LAOD_HIGH_SCORE",
   UPDATE_ATTEMPTED_LEVEL_HIGH_SCORE = "UPDATE_ATTEMPTED_LEVEL_HIGH_SCORE",
}
